import { SimpleViewDto } from '../../../common/dto/common.dto';
import { ConstrainV2, FilterFieldDataType } from '../../../common/dto/filter.dto';
import { FilterValueTypes } from '../../../hoc/WithFilter';
import { useGetAllAsset } from '../../../hook/useDataForSelect';
import FilterOptionsMultiple, { optionsContain } from '../simple-element/FilterOptionsMultiple';

type Props = {
  fieldDataType: FilterFieldDataType;
  field: string;
  label: string;
  value: SimpleViewDto[];
  constrain?: ConstrainV2;
  fieldSuffixMeta?: Record<string, string>;
  onFilterValueChanged: (
    fieldDataType: FilterFieldDataType,
    field: string,
    value?: FilterValueTypes,
    constrain?: ConstrainV2,
    fieldSuffixMeta?: Record<string, string>,
  ) => void;
};
const FilterAsset = (props: Props) => {
  const { data: dataAsset, isLoading: isLoadingAsset, error: errorAsset } = useGetAllAsset();
  return (
    <FilterOptionsMultiple
      fieldDataType={props.fieldDataType}
      field={props.field}
      label={props.label}
      isLoading={isLoadingAsset}
      options={dataAsset ?? []}
      value={props.value}
      constrain={props.constrain}
      fieldSuffixMeta={props.fieldSuffixMeta}
      onFilterValueChanged={props.onFilterValueChanged}
      fixedConstrain={optionsContain}
      hideConstrains
    />
  );
};

export default FilterAsset;
